<template>
    <svg
        :class="{ icon: true, 'icon--expanded': !isExpanded }"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M16 12L12 8M12 8L8 12M12 8V16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>

<script>
export default {
    name: 'IconCircleArrows',
    props: {
        isExpanded: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.icon {
    width: urem(24) !important;
    height: urem(24) !important;
    transition: 0.5s;

    &--expanded {
        transform: rotate(180deg);
    }
}
</style>
